import * as R from 'ramda';
import { createSelector } from 'reselect';

export default createSelector(
  (state, { rationId } = {}) => rationId || R.path(['routeParams', 'rationId'], state),

  R.identity,
);
